import Shelf from "../Shelf";

export default class Custom extends Shelf {
	public static code = "shelf_custom";
}
